import React from 'react'
import className from 'classnames'
import { getUserBackgroundColor } from '../../user/user-avatar/helpers'
import IconPeople from '../../icon/IconPeople'
import './GroupAvatar.less'
import { getTextClassForColor } from '../../../../../../shared/colorUtils'

const renderInitials = (group: { name: string }) => {
  const backgroundColor = getUserBackgroundColor(group)
  const textClass = getTextClassForColor(backgroundColor)
  return (
    <span
      className={className('GroupAvatar__icon', textClass)}
      style={{ backgroundColor }}
    >
      <IconPeople />
    </span>
  )
}

const GroupAvatar = ({
  group,
  size = 'normal'
}: {
  group: {
    name: string
  }
  size?: 'small' | 'normal'
}) => {
  return (
    <div className={className('GroupAvatar', size)}>
      {renderInitials(group)}
    </div>
  )
}

export default GroupAvatar
